import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import BookCardsComp from "../../../components/BookComponents/BookCards";
import BooksCollectionsCardsComp from "../../../components/BookComponents/BookCollectionsCards";

export const UserBooksCollectionsListPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="logo"
          showNotification
          showProfileBtn
        ></TopBar>
        <BooksCollectionsCardsComp></BooksCollectionsCardsComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserBooksCollectionsListPage;
